import styled, { css } from 'styled-components';
import { IconName } from './types';
import { Icon } from './Icon';
import { colors } from '@ardoq/design-tokens';

type AnimatedTreeChevronTransientProps = {
  $isUp?: boolean;
};
export const AnimatedTreeChevron = styled(Icon).attrs({
  iconName: IconName.CHEVRON_RIGHT,
})<AnimatedTreeChevronTransientProps>`
  transition: transform 0.2s ease-in-out;
  color: ${colors.grey500};
  ${({ $isUp }) =>
    $isUp &&
    css`
      && {
        transform: rotate(90deg);
        color: ${colors.grey700};
      }
    `}
`;
